import { Thead, Tr, Th, Flex, Text } from "@chakra-ui/react";
import useSort from "hooks/useSort";
import { TablePaddingX } from "components/SortableTable/SortableDynamicTable";

const SortableTableHeader = ({
  columns,
  tablePaddingX,
  hasExpansionRow,
}: {
  columns?: ColumnDefinition[];
  tablePaddingX: TablePaddingX;
  hasExpansionRow?: boolean;
}) => {
  const { activeSort, setCurrentSort, getSortIcon } = useSort();
  return (
    <Thead color="grey.500">
      <Tr verticalAlign="bottom">
        {columns?.map((column) => (
          <Th
            key={`${column.columnLabel}-header`}
            onClick={() => setCurrentSort?.(`${column.sortKey as string}`)}
            {...tablePaddingX}
            px={3}
            pointerEvents={column.sortKey ? "all" : "none"}
            cursor={column.sortKey ? "pointer" : "default"}
            style={{ paddingBottom: hasExpansionRow ? "12px" : "0px" }}
            borderColor="grey.50"
          >
            <Flex align="center">
              <Text
                textStyle="body2"
                color={
                  column.sortKey && activeSort?.key === column.sortKey
                    ? "grey.700"
                    : "grey.500"
                }
                textTransform="none"
                whiteSpace="nowrap"
                mr={1}
                fontWeight={
                  column.sortKey && activeSort?.key === column.sortKey
                    ? "bold"
                    : "medium"
                }
                w={column.alignRight ? "100%" : "unset"}
                textAlign={column.alignRight ? "right" : "unset"}
              >
                {column.columnLabel}
              </Text>
              {column.sortKey && getSortIcon(column)}
            </Flex>
          </Th>
        ))}
      </Tr>
    </Thead>
  );
};

export default SortableTableHeader;
